import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import 'focus-visible';
import '/assets/scripts/search';
 
Alpine.plugin(intersect)
Alpine.start()
